import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import {
  urlWorkingPart,
  urlWorkingPartSecured,
  urlMyWorkingPartSecured,
  urlDailyPartSecured,
  urlValidateWorkingPartSecured,
  urlConfirmWorkingPartSecured,
  urlExportDailyPartSecured,
  urlReportTaskHourSecured,
  urlConfirmAllWorkingPartSecured,
  urlAdmWorkingPartSecured,
  urlRemoveDailyWorkingPartSecured,
  urlUpdateDateSecured,
  urlWorkingPartUnitsSecured,
  urlExportWorkingPartSecured,
} from "../../api/urls";

import {
  PAGE_SIZE_10,
  CREATE_WORKING_PART,
  GET_WORKING_PART,
  UPDATE_WORKING_PART,
  DELETE_WORKING_PART,
  FILTER_WORKING_PART,
  UPDATE_PARTS_DATE,
} from "../../constants/index";
import moment from "moment-timezone";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.dateInit) {
      const dateInit = moment(filters.dateInit);
      filter += "&dateInit=" + dateInit.valueOf();
    }
    if (filters.dateEnd) {
      const dateEnd = moment(filters.dateEnd);
      filter += "&dateEnd=" + dateEnd.valueOf();
    }
    if (filters.articleUuid !== undefined)
      filter += "&articleUuid=" + filters.articleUuid;
    if (filters.batch !== undefined) filter += "&batch=" + filters.batch;
    if (filters.locationUuid !== undefined)
      filter += "&locationUuid=" + filters.locationUuid;

    // if (filters.date !== undefined) filter += "&date=" + filters.date;
    // if (filters.initTime !== undefined)
    //   filter += "&initTime=" + filters.initTime;
    // if (filters.endTime !== undefined) filter += "&endTime=" + filters.endTime;
    if (filters.userUuid !== undefined)
      filter += "&userUuid=" + filters.userUuid;
    if (filters.vivero !== undefined) filter += "&vivero=" + filters.vivero;
    // if (filters.rows !== undefined) filter += "&rows=" + filters.rows;
    if (filters.taskUuid !== undefined)
      filter += "&taskUuid=" + filters.taskUuid;
    // if (filters.comments !== undefined)
    //   filter += "&comments=" + filters.comments;
    // if (filters.taskTime !== undefined)
    //   filter += "&taskTime=" + filters.taskTime;
    if (filters.status !== undefined) filter += "&status=" + filters.status;
    if (filters.viveroUuid !== undefined)
      filter += "&viveroUuid=" + filters.viveroUuid;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Get WorkingPart by uuid.
 */
export const getWorkingPartByUuid = createAction(GET_WORKING_PART, (param) =>
  apiGet(urlWorkingPartSecured, param, true)()
);

/**
 * Get WorkingPart by uuid.
 */
export const getDailyPartByUuid = createAction("GET_DAILY_PART", (param) =>
  apiGet(urlDailyPartSecured, param, true)()
);

/**
 * Filter list WorkingPart.
 */
export const filterWorkingPart = createAction(
  FILTER_WORKING_PART,
  (filter, param) =>
    apiGet(urlWorkingPartSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Filter list WorkingPart.
 */
export const filterMyWorkingPart = createAction(
  "FILTER_MY_WORKING_PART",
  (filter, param) =>
    apiGet(urlMyWorkingPartSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Create WorkingPart.
 */
export const createWorkingPart = createAction(
  CREATE_WORKING_PART,
  (obj, param) => apiPost(urlMyWorkingPartSecured, obj, param, true)()
);

/**
 * Create WorkingPart.
 */
export const createAdminWorkingPart = createAction(CREATE_WORKING_PART, (obj) =>
  apiPost(urlAdmWorkingPartSecured, obj, undefined, true)()
);

/**
 * Update WorkingPart.
 */
export const modifyWorkingPart = createAction(
  UPDATE_WORKING_PART,
  (obj, param) => apiPut(urlMyWorkingPartSecured, obj, param, true)()
);

export const updatePartDates = createAction(UPDATE_PARTS_DATE, (obj, param) =>
  apiPut(urlUpdateDateSecured, obj, param, true)()
);

/**
 * Delete WorkingPart by uuid.
 */
export const removeWorkingPart = createAction(DELETE_WORKING_PART, (param) =>
  apiDelete(urlWorkingPartSecured, param, true)()
);

/**
 * Delete WorkingPart by uuid.
 */
export const validateDailyPart = createAction(
  "VALIDATE_WORKING_PART",
  (param) => apiPut(urlValidateWorkingPartSecured, {}, param, true)()
);

/**
 * Delete WorkingPart by uuid.
 */
export const confirmDailyPart = createAction("CONFIRM_WORKING_PART", (param) =>
  apiPut(urlConfirmWorkingPartSecured, {}, param, true)()
);

/**
 * Delete WorkingPart by uuid.
 */
export const confirmAllDailyPart = createAction(
  "CONFIRM_ALL_WORKING_PART",
  (filter) =>
    apiGet(
      urlConfirmAllWorkingPartSecured + generateFilterQuery(filter),
      undefined,
      true
    )()
);

/**
 * Filter list orders.
 */
export const listDailyPartToExport = createAction(
  "EXPORT_FILTER_ITEMS",
  (filter, param) =>
    apiGet(
      urlExportDailyPartSecured + generateFilterQuery(filter),
      param,
      true
    )()
);

/**
 * Filter list workingParts.
 */
export const listWorkingPartToExport = createAction(
  "EXPORT_FILTER_ITEMS",
  (filter, param) =>
    apiGet(
      urlExportWorkingPartSecured + generateFilterQuery(filter),
      param,
      true
    )()
);

/**
 * Filter list orders.
 */
export const reportTaskHour = createAction(
  "REPORT_TASK_HOUR",
  (filter, param) =>
    apiGet(
      urlReportTaskHourSecured + generateFilterQuery(filter),
      undefined,
      true
    )()
);

/**
 * Delete WorkingPart by uuid.
 */
export const removeDailyWorkingPart = createAction(
  "DELETE_DAILY_WORKING_PART",
  (param) => apiDelete(urlRemoveDailyWorkingPartSecured, param, true)()
);

/**
 * Filter list WorkingPart.
 */
export const filterAllWorkingPart = createAction(
  FILTER_WORKING_PART,
  (filter, param) =>
    apiGet(
      urlWorkingPartUnitsSecured + generateFilterQuery(filter),
      param,
      true
    )()
);
